import { validateNumber, validateString } from 'avilatek-utils';
import { Plan } from '../../models';

export function validatePlanForm({
  title,
  frequencies,
  freeCoupons,
  couponPrice,
  discountCoupons,
}: Partial<Plan>): string {
  if (!validateString(title) || String(title).length > 127) {
    return 'Nombre del plan es inválido';
  }

  if (!validateNumber(freeCoupons) || Number(freeCoupons) < 0) {
    return 'Puntos de cortesia inválidos';
  }

  if (!validateNumber(couponPrice) || Number(couponPrice) < 0) {
    return 'Precio de puntos extra inválido';
  }

  if (!validateNumber(discountCoupons) || Number(discountCoupons) < 0) {
    return 'Número de puntos extra totales inválido';
  }

  if (frequencies.length < 1) {
    return 'Debe agregar al menos una frecuencia';
  }

  const invalidFrequency = frequencies?.filter(
    (f) =>
      !validateString(f.time) ||
      !validateNumber(f.price) ||
      Number(f.price) < 0 ||
      Number(f.time) < 0
  );

  if (invalidFrequency.length > 0) {
    return 'Frecuencia inválida';
  }

  return '';
}
